
import './App.css';
import { Page } from './component/Page';

function App() {
  return (
    <div className="App">
      <Page/>
    </div>
  );
}

export default App;
